import { FC } from "react";
import { Flex, Image } from "@chakra-ui/react";
import { useCurrentDiagnosticUser } from "~/hooks/useCurrentDiagnosticUser";
import ConceiveLogo from "~/images/logos/conceive.svg";
import { DiagnosticsSignOut } from "./DiagnosticsSignOut";

const HEADER_STANDARD_HEIGHT = "4.875rem";

export const DiagnosticsHeader: FC = () => {
  const currentDiagnosticUser = useCurrentDiagnosticUser();

  return (
    <Flex
      alignItems="center"
      as="header"
      bg="white"
      boxShadow="0 2px 10px 0 rgb(0 0 0 / 5%)"
      h={HEADER_STANDARD_HEIGHT}
      justify="center"
      position="sticky"
      top="0"
      w="100%"
      zIndex={3}
    >
      <Flex
        align="center"
        as="nav"
        w="100%"
        px={4}
        wrap="wrap"
        position="relative"
      >
        <Flex flex="1" />
        <Flex flex="1" justify="center">
          <Image
            alt="Conceive logo"
            h="2rem"
            loading="eager"
            w="12rem"
            src={ConceiveLogo}
          />
        </Flex>
        <Flex flex="1" justify="flex-end">
          {currentDiagnosticUser && <DiagnosticsSignOut />}
        </Flex>
      </Flex>
    </Flex>
  );
};
